import { connect } from 'react-redux'

import { getFormSettings } from '../selectors'

function InnerComponent({ WrappedComponent, ...rest }) {
  return <WrappedComponent {...rest} />
}

const ComponentWrapper = connect(state => ({
  formSettings: getFormSettings(state),
}))(InnerComponent)

function withFormSettings(component) {
  return function WithColorComponent(props) {
    return <ComponentWrapper WrappedComponent={component} {...props} />
  }
}

export default withFormSettings
